<template>
  <div class="dialog-wrap">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.dialog-wrap {
  z-index: 9;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: auto;
  background-color: @bg--gray;
  .add-edit-form {
    flex: 1;
    overflow: auto;
    margin-top: 30px;
  }
}
</style>
